import { render, staticRenderFns } from "./LanguageFilter.vue?vue&type=template&id=c59bc740&scoped=true&"
import script from "./LanguageFilter.vue?vue&type=script&lang=js&"
export * from "./LanguageFilter.vue?vue&type=script&lang=js&"
import style0 from "./LanguageFilter.vue?vue&type=style&index=0&id=c59bc740&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59bc740",
  null
  
)

export default component.exports